import { useCallback } from 'react';
import { fetchProductGroup } from '../utils/api';
import { useFetch } from './use-fetch';
import type { ProductGroupResponse, RepairBookingSession } from '../models/repair-bookings';

const PRODUCT_GROUP_CONFIG: Record<string, { type: string; title: string }> = {
    manufacturers: {
        type: 'grid',
        title: '修理する機種のメーカーを選択してください',
    },
    models: {
        type: 'list',
        title: '機種を選択してください',
    },
    colors: {
        type: 'list',
        title: 'カラーを選択してください',
    },
};

const DEFAULT_CONFIG = { type: 'list', title: '選択してください' };

const useProductGroup = (session: RepairBookingSession, groupKey: string) => {
    const fetcher = useCallback((): Promise<ProductGroupResponse> => {
        const shopId = session.type !== 'edit' ? (session.designatedShop?.shop_id ?? null) : null;
        return fetchProductGroup(session.csrfToken, session.sessionId, groupKey, shopId);
    }, [session, groupKey]);

    const { data, error, loading } = useFetch(fetcher);

    const config = data ? (PRODUCT_GROUP_CONFIG[data.type] ?? DEFAULT_CONFIG) : DEFAULT_CONFIG;

    return { group: data, config, loading, error };
};

export default useProductGroup;
